import { isEqual } from "lodash";
import { useState } from "react";

import { AvailabilityStatusesQuickFilter } from "./interfaces";

export const useAvailabilityStatusesQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<AvailabilityStatusesQuickFilter>({
    availabilityStatuses: {
      availabilityStatusesId: null,
    },
  });

  const handleChangeQuickFilter = (
    filter: keyof AvailabilityStatusesQuickFilter,
    value: AvailabilityStatusesQuickFilter["availabilityStatuses"]
  ) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    availabilityStatusesQuickFilter: quickFilter,
    setAvailabilityStatusesQuickFilter: handleChangeQuickFilter,
  };
};
